import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, filters) => ({
        operable: filters.operable,
        date:     Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'CMDBGlobalLast13Months',
        endpoint:           endpoints.cmdb.globalLast13M,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => [
            {
                name: 'global',
                data: response.results.map(i => ({y: i.amount, x: i.period * TIMESTAMP_MULTIPLY, period: i.period, amount: i.amount}))
            }
        ]
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/CMDBGlobalLast13Months.js